
class Config { }

//后台服务端接口
// Config.baseUrl = window.location.protocol + '//' +  "api-ed-dev.kpexapp.com/";
// Config.baseUrl = window.location.protocol + '//' + "api-uat.ed-connect.asia/";
// Config.baseUrl = window.location.protocol + '//' +  "api.ed-connect.asia/";
// Config.baseUrl = window.location.protocol + '//' + process.env.BASE_API;
Config.baseUrl ='https://' + process.env.BASE_API;

Config.baseApi = Config.baseUrl + "admin/";
Config.httpTimeout = 30000;//30秒超时

//阿里云 图片地址
Config.imgUrl = "https://kpexapp-dev.oss-cn-hongkong.aliyuncs.com/ui/back/";
Config.myKrpanoUrl = "https://kpexapp-dev.oss-cn-hongkong.aliyuncs.com/krpano/";

//全景地址
Config.krpanoUrl = "https://qjzy.yjia88.com/";

//小程序码地址
Config.wxmpUrl = "http://wxmp.jingcailm.cn";

//处理编译时内存溢出
//npm install -g increase-memory-limit
//increase-memory-limit

//接口加密密钥
Config.key = "12345678";

//cookie 时间（天）
Config.cookie_date = "1";

//每页导出行数
Config.export_pages = 0;
Config.export_limit = 2000;

//缓存页面个数
Config.cache_page_qty = 8;

//图表高度 占屏幕的上半部
Config.chart_height = '260px';
Config.chart_veline_extend = {
    barWidth: '22',
    'xAxis.0.axisLabel.rotate': 30
};
Config.chart_veline_extend2 = {
    barWidth: '22',
    'xAxis.0.axisLabel.rotate': 30,
    legend: {
        textStyle: {
            color: 'white',
        }
    }
};
Config.chart_histogram_extend = {
    barWidth: '22',
    'xAxis.0.axisLabel.rotate': 30,
    series: {
        label: { show: true, position: "top" }
    }
};
Config.chart_grid = {
    top: 45,
    bottom: 35
};
Config.chart_pie_settings = {
    offsetY: 140,
    roseType: 'radius'
};

//默认店铺
Config.shopId = "761073AB83BA4965951C9EDFF4D6527D";

//富文本需要的插件
Config.editerFx = [
    'head',  // 标题
    'bold',  // 粗体
    'fontSize',  // 字号
    'image',
    'video',
    'italic',  // 斜体
    'underline',  // 下划线
    'list',  // 列表
    'strikeThrough',  // 删除线
    'foreColor',  // 文字颜色
    'justify',  // 对齐方式
    'emoticon',
    'undo',  // 撤销
    'redo'  // 重复
];

//语言选择
Config.langs = [
    {
        key: "zh-CN",
        val: "中文简体"
    },
    {
        key: "zh-TW",
        val: "中文繁體"
    },
    {
        key: "en",
        val: "English"
    },
];

Config.chart_colors = [
    '#fa6e86',
    '#2d8cf0',
    '#db6025',
    '#40AE2B',
    '#5ab1ef',
    '#fe9900',
    '#758afe',
    '#0067a6',
    '#29b1d9',
    '#f3cd22',
    '#e34836',
    '#44866b'
];

//默认邮箱尾号
Config.emails = ['@qq.com', '@163.com', '@sina.com', '@yahoo.com.hk', '@hotmail.com', '@gmail.com'];
Config.scroll_width = '10px';

export default Config



// WEBPACK FOOTER //
// ./src/utils/config.js